import { pg } from "~/pg.server";
import { gameName } from "./common";
import { lstring, Realm, tt } from "./Lang";
import { OurLoaderArgs } from "./Loaders";
import { and, eq } from "drizzle-orm";
import { loadMarkdown } from "./Markdown.server";
import { getContributorsForPage } from "./page";

export function getDescription(props: {
  realm: Realm;
  quest: {
    name: lstring;
    desc: string;
  };
}) {
  const { realm, quest } = props;
  const t = tt.bind(null, realm.lang);
  const game = gameName(realm.game);
  return t({
    en: `Quest ${quest.name.en}. ${quest.desc} ${game}`.trim(),
    ru: `Квест ${quest.name.ru} (${quest.name.en}). ${quest.desc} ${game}`.trim(),
  });
}

export const questCategories = [
  {
    name: { en: "Starting Quests", ru: "Стартовые квесты" },
    categories: [
      {
        name: {
          en: "Talking Island Village",
          ru: "Деревня Говорящего Острова",
        },
        icon: "skill4416_human",
        quests: [
          258, 306, 157, 6, 303, 158, 152, 257, 153, 155, 1, 151, 154, 156, 101,
          104,
        ],
        path: "talking-island-village",
      },
      {
        name: { en: "Elven Village", ru: "Деревня Эльфов" },
        icon: "skill4416_elf",
        quests: [
          160, 7, 162, 164, 313, 159, 316, 105, 163, 260, 261, 2, 102, 317, 161,
          267,
        ],
        path: "elven-village",
      },
      {
        name: { en: "Dark Elven Village", ru: "Деревня Темных Эльфов" },
        icon: "skill4416_darkelf",
        quests: [
          8, 264, 262, 319, 3, 169, 170, 103, 263, 165, 168, 167, 324, 265, 106,
          320, 166,
        ],
        path: "dark-elven-village",
      },
      {
        name: { en: "Orc Village", ru: "Деревня Орков" },
        icon: "skill4416_orc",
        quests: [273, 275, 107, 274, 276, 272, 277, 271, 4, 9],
        path: "orc-village",
      },
      {
        name: { en: "Dwarven Village", ru: "Деревня Гномов" },
        icon: "skill4416_dwarf",
        quests: [296, 108, 292, 10, 294, 293, 295, 297, 291, 5],
        path: "dwarven-village",
      },
    ],
  },
  {
    name: { en: "Class Change Quests", ru: "Квесты на смену класса" },
    categories: [
      {
        name: { en: "1st Class", ru: "Квест на 1 профу" },
        icon: "one",
        quests: [
          401, 402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414,
          415, 416, 417, 418,
        ],
        path: "1st-class",
      },
      {
        name: { en: "2nd Class", ru: "Квест на 2 профу" },
        icon: "two",
        quests: [
          231, 216, 221, 225, 215, 233, 220, 232, 211, 222, 223, 219, 227, 214,
          230, 228, 213, 224, 212, 229, 218, 226, 217,
        ],
        path: "2nd-class",
      },
      {
        name: { en: "3rd Class", ru: "Квест на 3 профу" },
        icon: "three",
        quests: [],
        path: "3rd-class",
      },
    ],
  },
  {
    name: { en: "Pets' Quests", ru: "Квесты на питомцев" },
    categories: [
      {
        name: { en: "Wolf Collar", ru: "Квест на Волка" },
        icon: "etc_prefect_belt_i00",
        quests: [],
        path: "419-get-a-pet",
      },
      {
        name: { en: "Baby Buffalo", ru: "Квест на Быка" },
        icon: "etc_buffalo_panpipe_i00",
        quests: [],
        path: "42-help-the-uncle",
      },
      {
        name: { en: "Baby Kookaburra", ru: "Квест на Птицу" },
        icon: "etc_kukaburo_ocarina_i00",
        quests: [],
        path: "44-help-the-son",
      },
      {
        name: { en: "Baby Cougar", ru: "Квест на Тигра" },
        icon: "etc_cougar_chime_i00",
        quests: [],
        path: "43-help-the-sister",
      },
      {
        name: { en: "Dragonflute", ru: "Квест на Дракончика" },
        icon: "etc_flute_i00",
        quests: [],
        path: "43-help-the-sister",
      },
      {
        name: { en: "Dragon Bugle", ru: "Квест на Ездового Дракона" },
        icon: "etc_bugle_i00",
        quests: [],
        path: "421-little-wings-big-adventure",
      },
    ],
  },
  {
    name: { en: "Boss Quests", ru: "Квесты на боссов" },
    categories: [
      {
        name: { en: "Antharas", ru: "Антарас" },
        icon: "accessory_earring_of_antaras_i00",
        quests: [],
        path: "337-audience-with-the-land-dragon",
      },
      {
        name: { en: "Valakas", ru: "Валакас" },
        icon: "accessory_necklace_of_valakas_i00",
        quests: [],
        path: "618-into-the-flame",
      },
      {
        name: { en: "Baium", ru: "Баюм" },
        icon: "accessory_ring_of_baium_i00",
        quests: [],
        path: "348-an-arrogant-search",
      },
    ],
  },
  {
    name: { en: "Useful quests", ru: "Полезные квесты" },
    categories: [
      {
        name: { en: "Enhance Your Weapon", ru: "Прокачка Кристалла души (SA)" },
        icon: "etc_crystal_red_i00",
        quests: [],
        path: "350-enhance-your-weapon",
      },
      {
        name: { en: "Repent Your Sins", ru: "Квест на отмытие PK" },
        icon: "etc_leash_i00",
        quests: [],
        path: "422-repent-your-sins",
      },
      {
        name: {
          en: "Accessories (Rabbit, Raccoon, Cat)",
          ru: "Квест на уши (Кролика, Енота, Кота)",
        },
        icon: "accessory_cat_ear_i00",
        quests: [],
        path: "32-an-obvious-lie",
      },
      {
        name: { en: "Subclass", ru: "Саб-класс" },
        icon: "etc_badge_gold_i00",
        quests: [],
        path: "",
      },
      {
        name: { en: "Noblesse", ru: "Дворянство" },
        icon: "skill1323",
        quests: [],
        path: "",
      },
    ],
  },
  {
    name: { en: "Fishing Quests", ru: "Квесты для рыбалки" },
    categories: [
      {
        name: { en: "Fishing Rod", ru: "Удочка" },
        icon: "weapon_fishing_rod_i00",
        quests: [],
        path: "39-red-eyed-invaders",
      },
      {
        name: { en: "Fishing Shots", ru: "Поплавки" },
        icon: "etc_spirit_bullet_fish_i00",
        quests: [],
        path: "426-quest-for-fishing-shot",
      },
    ],
  },
];

export async function questMdPage(cx: OurLoaderArgs, questId: number) {
  const page = await pg.db
    .select({
      id: pg.mdPages.id,
      contentEn: pg.mdRevisions.contentEn,
      contentRu: pg.mdRevisions.contentRu,
    })
    .from(pg.mdPages)
    .where(
      and(eq(pg.mdPages.questId, questId), eq(pg.mdPages.isDeleted, false))
    )
    .innerJoin(pg.mdRevisions, eq(pg.mdPages.revisionId, pg.mdRevisions.id))
    .then((res) => res.at(0));

  if (!page) {
    return;
  }
  const contributors = await getContributorsForPage(page.id);
  return (
    page && {
      ...page,
      contributors,
      content:
        page?.contentEn && cx.realm.lang === "en"
          ? await loadMarkdown(
              page?.contentEn,
              cx.gd.all_gd!,
              cx.realm.lang,
              cx.realm.game
            )
          : page?.contentRu
          ? await loadMarkdown(
              page?.contentRu,
              cx.gd.all_gd!,
              cx.realm.lang,
              cx.realm.game
            )
          : page?.contentEn &&
            (await loadMarkdown(
              page?.contentEn,
              cx.gd.all_gd!,
              cx.realm.lang,
              cx.realm.game
            )),
    }
  );
}
